<template>
  <div class="comp-cert-tool">
    <div class="row head align-center">
      <div class="tab row column-s grid-12-s">
        <div @click="changeTab('comp')" :class="tab.comp ? 'active' : ''">
          COMPETÊNCIAS
        </div>
        <div @click="changeTab('cert')" :class="tab.cert ? 'active' : ''">
          CERTIFICADOS
        </div>
        <div @click="changeTab('tool')" :class="tab.tool ? 'active' : ''">
          FERRAMENTAS
        </div>
      </div>
      <div class="title grid hide-s">
        Competências, Certificados e Ferramentas
      </div>
    </div>

    <div class="content">
      <Competence v-if="tab.comp" :modal="modal"  />
      <Tree v-if="tab.cert" :modal="certificates" :callback="modal.callback" />
      <Tree v-if="tab.tool" :modal="tools" :callback="modal.callback" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Competence from "@/components/modal/Competence.vue";
import Tree from "@/components/modal/Tree.vue";
export default {
  name: "CompCertTool",
  props: {
    modal: Object,
  },
  components: {
    Competence,
    Tree,
  },
  data() {
    return {
      tab: {
        comp: true,
        cert: false,
        tool: false,
      },
    };
  },
  methods: {
    ...mapActions("user", ["CERTIFICATES_LIST", "TOOLS_LIST"]),
    changeTab(tab) {
      this.tab = {};
      this.tab[tab] = true;
    },
  },
  beforeMount() {
    if (this.modal.tab) {
      this.tab.comp = false;
      this.tab[this.modal.tab] = true;
    }
    this.CERTIFICATES_LIST();
    this.TOOLS_LIST();
  },
  computed: {
    ...mapGetters("user", ["certificates", "tools"]),
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.comp-cert-tool {
  color: $gray-9;
  padding: 10px 25px;
  padding-top: 25px;
  @media (min-width: $small) {
    width: $medium;
  }
  @media (min-width: $large) {
    width: $large;
  }
  @media (min-width: 850px) and (max-width: 1030px) {
    width: 800px;
  }
  .head {
    border-bottom: 1px solid $gray-9;
  }
  .title {
    font-size: 17px;
    letter-spacing: 0.6px;
    font-weight: bold;
    text-align: right;
  }
  .tab {
    color: $gray-9;
    letter-spacing: 0.5px;
    font-weight: bold;
    font-size: 13px;
    div {
      height: 25px;
      background: #fff;
      border: 2px solid #ccc;
      border-bottom: none;
      padding: 7px 15px;
      border-radius: 7px 7px 0 0;
      line-height: 25px;
      cursor: pointer;
      background: $white-3;
      &.active {
        background: $supporter-1;
        color: white;
        border: 2px solid $supporter-1;
        border-bottom: none;
      }
    }
  }
}
</style>
